import React, { useState } from 'react';

import { useTranslation } from '@mint-lib/i18n';
import { Add } from '@mint-lib/icons';
import {
  Button,
  Checkbox,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogOverlay,
  DialogRoot,
  DialogTitle,
  typographyVariants,
} from '@mint-lib/tw-components';

import AcceptedPlatformsReadOnly from '../../AcceptedPlatform/AcceptedPlatrofmsReadOnly.jsx';

type AcceptProps = {
  isLoading: boolean;
  onCloseDialog: () => void;
  onAccept: () => void;
  onAcceptNewVersion: () => void;
};

const AcceptReadOnly = ({
  isLoading,
  onCloseDialog,
  onAccept,
  onAcceptNewVersion,
}: AcceptProps) => {
  const { t } = useTranslation('@mint-lib/recommendations-circuit');
  const [isSure, setIsSure] = useState(false);

  const onSureChange = () => {
    setIsSure((prev) => !prev);
  };

  return (
    <Dialog open modal>
      <DialogOverlay />
      <DialogRoot size={'s'}>
        <DialogHeader onClose={onCloseDialog}>
          <DialogTitle>{t('Accept this suggestion?')}</DialogTitle>
        </DialogHeader>

        <DialogContent className="flex flex-col gap-4">
          <AcceptedPlatformsReadOnly />
          <div className="flex flex-row items-center gap-2">
            <Checkbox onCheckedChange={onSureChange} checked={isSure} />
            <p className={typographyVariants({ variant: 'bodyLong01' })}>
              {t('I understand this will be applied to the media plan.')}
            </p>
          </div>
        </DialogContent>
        <DialogFooter>
          <Button
            disabled={isLoading || !isSure}
            onClick={onAcceptNewVersion}
            variant="outlined"
            color="primary"
            size="large"
          >
            {<Add />}
            {t('Create New')}
          </Button>
          <Button
            disabled={isLoading || !isSure}
            onClick={onAccept}
            variant="contained"
            color="primary"
            size="large"
          >
            {t('Update Current')}
          </Button>
        </DialogFooter>
      </DialogRoot>
    </Dialog>
  );
};

export default AcceptReadOnly;
